 <template>
  <div class="generic-checkbox justify-content-end" v-show="elementActive">
    <div class="form-check col-8">
      <input class="form-check-input" type="checkbox" :id="formField.element_id" v-model="isChecked" :disabled="elementDisabled">
      <label class="form-check-label" :for="formField.element_id" v-html="label">
      </label>
    </div>
    <div class="col-2 field-error">
        {{errors}}
    </div>
  </div>
</template>

<script>
import PropsMixin from './FormElementPropsMixin'
import ComputedMixin from './FormElementComputedMixin'
import ProgramSpecificMixin from './ProgramSpecificMixin'

export default {
  name: 'GenericCheckbox',
  mixins: [PropsMixin, ComputedMixin, ProgramSpecificMixin],
  data () {
    return {
      isChecked: false
    }
  },
  computed: {
    values () {
      return this.formField.formListItems
    }
  },
  mounted () {
    if (this.values && this.currentValue === this.values[0].value) {
      this.isChecked = true
    }
  },
  watch: {
    currentValue (newValue) {
      if (newValue === this.values[0].value) {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
    },
    isChecked (newValue) {
      if (newValue) {
        this.currentValue = this.values[0].value
      } else {
        this.currentValue = null
      }
    }
  }
}
</script>
<style scoped>
.generic-checkbox {
  padding-top: 7px;
}
</style>
